<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" width="55%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="mini">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <!-- <el-descriptions-item label="第几轮报价" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="roundNo" style="margin-bottom: 0;">
                        <span>{{dataForm.roundNo}}</span>
                    </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item label="工序" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="process" style="margin-bottom: 0;">
                        <el-input size="mini" v-if="viewFlag !== 'view'" v-model="dataForm.process" placeholder="请输入工序名称" clearable></el-input>
                        <span v-else>{{dataForm.process}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="模具/夹具/检具名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="moldFixtureCheckingToolName" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.moldFixtureCheckingToolName" placeholder="模具/夹具/检具名称"></el-input>
                        <span v-else>{{dataForm.moldFixtureCheckingToolName}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="树脂、压铸、冲压模具重量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="resinDieCastingStampingDieWeight" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.resinDieCastingStampingDieWeight" placeholder="树脂、压铸、冲压模具重量"></ctl-number>
                        <span v-else>{{dataForm.resinDieCastingStampingDieWeight}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="总投资额" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="totalInvestment" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.totalInvestment" placeholder="总投资额"></ctl-number>
                        <span v-else>{{dataForm.totalInvestment}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="同种模具总数" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="totalNumberOfTheSameMold" style="margin-bottom: 0;">
                        <ctl-number :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.totalNumberOfTheSameMold" placeholder="同种模具总数"></ctl-number>
                        <span v-else>{{dataForm.totalNumberOfTheSameMold}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="每模取数" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="numberPerModulus" style="margin-bottom: 0;">
                        <ctl-number :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.numberPerModulus" placeholder="每模取数"></ctl-number>
                        <span v-else>{{dataForm.numberPerModulus}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="寿命" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="life" style="margin-bottom: 0;">
                        <ctl-number :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.life" placeholder="寿命"></ctl-number>
                        <span v-else>{{dataForm.life}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="自制/外协" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="selfMade" style="margin-bottom: 0;">
                        <el-select size="mini" v-if="viewFlag !== 'view'" v-model="dataForm.selfMade" placeholder="请选择" clearable>
                            <el-option v-for="item in selfMadeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <span v-else>{{dataForm.selfMade}}</span>
                        <!-- <el-input v-if="viewFlag !== 'view'" v-model="dataForm.selfMade" placeholder="自制"></el-input> -->
                        
                    </el-form-item>
                </el-descriptions-item>
                <!-- <el-descriptions-item label="外协" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="outsourcing" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.outsourcing" placeholder="外协"></el-input>
                        <span v-else>{{dataForm.outsourcing}}</span>
                    </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item label="供应商名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="supplierName" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.supplierName" placeholder="供应商名称"></el-input>
                        <span v-else>{{dataForm.supplierName}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="制造周期" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="makingTime" style="margin-bottom: 0;">
                        <ctl-number v-if="viewFlag !== 'view'" v-model="dataForm.makingTime" placeholder="制造周期"></ctl-number>
                        <span v-else>{{dataForm.makingTime}}</span>
                    </el-form-item>
                </el-descriptions-item>


              <el-descriptions-item label="支付比例 | %" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item style="margin-bottom: 0;">
                  <!--                  <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.payRatio" placeholder="支付比例"></ctl-number>
                                    <span v-else>{{dataForm.payRatio}}</span>-->
                  <span>{{dataForm.payRatio}}%</span>
                </el-form-item>
              </el-descriptions-item>

              <el-descriptions-item label="摊销数量" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item style="margin-bottom: 0;">
                  <!--                  <ctl-number v-if="viewFlag !== 'view'" v-model="dataForm.amortizationNum" placeholder="摊销数量"></ctl-number>-->
                  <!--                  <span v-else>{{dataForm.amortizationNum}}</span>-->
                  <span>{{dataForm.amortizationNum}}</span>
                </el-form-item>
              </el-descriptions-item>

              <el-descriptions-item label="摊销金额" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="amortizationPrice" style="margin-bottom: 0;">
                  <span>
                    {{
                      isNaN((dataForm.totalInvestment*(1- dataForm.payRatio/100)).toFixed(2))?
                               0:(dataForm.totalInvestment*(1- dataForm.payRatio/100)).toFixed(2)
                    }}
                  </span>
                </el-form-item>
              </el-descriptions-item>

              <el-descriptions-item label="摊销单价" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="partAllocation" style="margin-bottom: 0;">
                  <span>
                    {{
                      isNaN(((dataForm.totalInvestment*(1-dataForm.payRatio/100)) / dataForm.amortizationNum).toFixed(2))?
                          0:((dataForm.totalInvestment*(1-dataForm.payRatio/100)) / dataForm.amortizationNum).toFixed(2)
                    }}
                  </span>
                </el-form-item>
              </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="mini" type="primary" v-if="viewFlag != 'view'" plain @click="dataFormSubmit()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    PROCESS,
    getprocessByValue
} from '@/utils/const'
import {
    createToolsCost,
    getToolsCostById,
    editToolsCost,
    getRfqBaseById
} from "@/controller/quotation";
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
export default {
    components: {
        CtlNumber
    },
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            PROCESS: PROCESS,
            viewFlag: '',
            viewData: {},
            getprocessByValue: getprocessByValue,
            selfMadeList:[{value: '自制', label: '自制'},{value: '外协', label: '外协'}],
            dataForm: {
                id: 0,
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                roundNo: '',
                process: '',
                moldFixtureCheckingToolName: '',
                resinDieCastingStampingDieWeight: '',
                totalInvestment: '',
                totalNumberOfTheSameMold: '',
                numberPerModulus: '',
                life: '',
                payRatio:'',
                amortizationNum:'',
                partAllocation: '',
                amortizationPrice:'',
                selfMade: '',
                outsourcing: '',
                supplierName: '',
                makingTime: ''
            },
        };
    },
    methods: {
        // 初始化
        init(id, viewFlag, data, rfqId) {
            mapping(data, this.dataForm)
            this.dataForm.id = id || 0;
            this.dataForm.rfqId = rfqId
            this.viewFlag = viewFlag
            // this.dataForm.technicalNotifId = technicalNotifId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查单条
                    getToolsCostById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    getRfqBaseById({}, this.dataForm.rfqId).then(data => {
                        if (data && data.code === '00') {
                            if("2" != data.body.rfqStatus) {
                                this.$message.warning("询价单不是询价中状态，不允许修改报价相关信息")
                            } else {
                                let Params = {
                                    id: this.dataForm.id || undefined,
                                    ...this.dataForm,
                                    amortizationPrice : isNaN((this.dataForm.totalInvestment*(1- this.dataForm.payRatio/100)).toFixed(4))?
                                           0:(this.dataForm.totalInvestment*(1- this.dataForm.payRatio/100)).toFixed(4),
                                    partAllocation : parseInt(this.dataForm.amortizationNum) > 0 ?
                                      (isNaN(((this.dataForm.totalInvestment * (1-this.dataForm.payRatio/100)) / this.dataForm.amortizationNum).toFixed(4))?
                                      0:((this.dataForm.totalInvestment * (1-this.dataForm.payRatio/100)) / this.dataForm.amortizationNum).toFixed(4)):'0',

                                };
                                if (this.dataForm.id) {
                                    // 更新零件
                                    editToolsCost(Params)
                                        .then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "操作成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.view.visible = false;
                                                        this.$emit("refreshDataList");
                                                        this.$emit('getDataListAll');
                                                    },
                                                });
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                } else {
                                    // 创建零件
                                    createToolsCost(Params)
                                        .then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "操作成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.view.visible = false;
                                                        this.$emit("refreshDataList");
                                                        this.$emit('getDataListAll');
                                                    },
                                                });
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                }
                            }
                        }
                    })
                }
            });
        },
        getStyle() {
            return 'width: 200px; text-align: right'
        },
        getStyle2() {
            return 'width: 507.5px;'
        }
    },
};
</script>

<style lang="scss">
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
